import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.tsx'
import SafeAreaProbe from './components/SafeAreaProbe.tsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || '',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1.0,
  enabled: import.meta.env.PROD,
})

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    navigator.serviceWorker.register(import.meta.env.BASE_URL + 'sw.js').catch(() => {});
  } else {
    // Never run the service worker against the dev server — a stale registration
    // left from a previous session intercepts the whole origin (PWA *and* mobile
    // browser) and can serve a broken shell, showing a blank screen on devices.
    // Unregister any existing one so the phone self-heals on next load.
    navigator.serviceWorker.getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{ padding: 24, textAlign: 'center' }}>Something went wrong. Please refresh.</p>}>
      <App />
      {/* ?safearea=1 — real viewport/inset numbers off a real device. None of
          this is reproducible in a desktop browser, which reports 0 for every
          inset. Sits at the root so it covers every route. */}
      {window.location.search.includes('safearea=1') && <SafeAreaProbe />}
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
